//app.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ResetPassword from './pages/home/ResetPassword'; // Ajusta el path según tu estructura

import PrivateRoute from './security/PrivateRoute';
import Login from './pages/home/Login'; // Cambié esta línea
import MainLoggedIn from './pages/home/MainLoggedIn';  // Cambié esta línea
import ProductInfo from './components/LoggedOut/ProductInfo.jsx'; // Cambié esta línea
import InviteRedirect from './pages/invite/InviteRedirect.jsx';
import NotFound from './pages/404/NotFound.jsx';
import MarketPlace from './pages/marketplace/MarketPlace.jsx';

import './App.css';

function App() {
  return (
      <Routes>
        <Route path="/" element={<MarketPlace />} />
        <Route path="/unirse/:code" element={<InviteRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <MainLoggedIn />
            </PrivateRoute>
          }
        />
         
        
        <Route path="/products/:fcNombre/:fiProducto" element={<ProductInfo />} />
        <Route path="*" element={<NotFound/>}/>
      </Routes>
  );
}

export default App;
